import { Component } from '@angular/core';
import { RouterConst } from '../../../../globals/RoutersConst';
import { BreadcrumbService } from '../../../../breadcrumb.service';
import { SessionSummaryModel } from './session-summary.model';
import { Globals } from '../../../../globals/Globals';
import { CookieService } from 'ngx-cookie-service';
import { HttpClient } from '@angular/common/http';
import { DashboardDataService } from '../../../../services/dashboard-data.service';
import { WsService } from '../../../../services/websocket/WsService';
import { ClientsService } from '../../../../services/clients/clients.service';
import { SuperClass } from '../../../../superclass/SuperClass';

@Component({
  selector: 'app-session-summary',
  templateUrl: './session-summary.component.html',
  styleUrls: ['./session-summary.component.css'],
})
export class SessionSummaryComponent extends SuperClass {
  venueGroupsTree;
  selectedVenueGroup;
  btnDsbl = true;
  end: Date;
  start: Date;
  selectedRow;
  session: SessionSummaryModel[];

  constructor(
    private breadcrumbService: BreadcrumbService,
    private dashboardDataService: DashboardDataService,
    private clientsService: ClientsService,
    private wsService: WsService,
    private httpClient: HttpClient,
    private cookiesService: CookieService,
  ) {
    super(
      clientsService,
      wsService,
      dashboardDataService,
      httpClient,
      cookiesService,
    );

    this.breadcrumbService.setItems([
      { label: 'Dashboards' },
      { label: 'Reporting' },
      {
        label: 'Session Summary Report',
        routerLink: [{ outlets: { sub: [RouterConst.SESSION_SUMMARY] } }],
      },
    ]);

    this.end = new Date();
    this.start = new Date(this.end.getTime() - 24 * 60 * 60 * 1000);

    this.http_getTreeInfo(
      {
        withLocations: true,
        getAll: true,
        withNoParent: false,
      },
      (data: any) => {
        if (data.result === Globals.RESPONSE_RESULT_SUCCESS) {
          this.venueGroupsTree = JSON.parse(data.payload);
        }
      },
    );
  }

  reloadData(): void {}

  getSessions() {
    const request = {
      start: this.start.getTime(),
      end: this.end.getTime(),
      venueGroup: this.selectedVenueGroup.data,
    };

    this.http_postSummary(
      request.venueGroup,
      request.start,
      request.end,
      (response: any) => {
        if (response.result === 'OK') {
          this.session = response.payload;
        }
      },
    );
  }

  onVenueGroupSelect(e) {
    this.btnDsbl = false;
  }

  selectRow(e) {
    this.selectedRow = new SessionSummaryModel(e.data);
  }

  getWebSocketIdentifier(): string {
    return undefined;
  }
}



// WEBPACK FOOTER //
// /home/sgurin/IdeaProjects/cosy/cp-builder/src/app/components/dashboards/reporting/session-summary/session-summary.component.ts